var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.984863 10C1.76862 5.73313 5.50693 2.5 10.0004 2.5C14.4938 2.5 18.2322 5.73313 19.0159 10C18.2322 14.2668 14.4938 17.5 10.0004 17.5C5.50693 17.5 1.76862 14.2668 0.984863 10ZM10.0004 14.1667C12.3016 14.1667 14.1671 12.3012 14.1671 10C14.1671 7.69882 12.3016 5.83333 10.0004 5.83333C7.6992 5.83333 5.83371 7.69882 5.83371 10C5.83371 12.3012 7.6992 14.1667 10.0004 14.1667ZM10.0004 12.5C8.61966 12.5 7.50038 11.3807 7.50038 10C7.50038 8.61925 8.61966 7.5 10.0004 7.5C11.3811 7.5 12.5004 8.61925 12.5004 10C12.5004 11.3807 11.3811 12.5 10.0004 12.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisible);
export default __webpack_public_path__ + "static/media/icon_visible.e5617f71b4a48670bb0ef8fdfda7d2f2.svg";
export { ForwardRef as ReactComponent };